import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
`;

export const LeftCol = styled.div`
	display: flex;
	flex-direction: column;
	margin-right: var(--margin-3);
	body[dir='rtl'] & {
		margin-right: 0;
		margin-left: var(--margin-3);
	}
	.icon {
		border-radius: var(--small-border-radius);
		width: 5rem;
		height: 5rem;
		display: flex;
		justify-content: center;
		align-items: center;
		background: var(--statistic-card-bg-color);
		color: var(--statistic-card-text-color);
	}
`;

export const RightCol = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

	> div:first-of-type {
		display: grid;
		grid-template-columns: auto auto;
	}
`;

export const BottomContainer = styled.div`
	margin-top: 0;
	display: flex;
	width: 100%;
	justify-content: flex-end;
	position: absolute;
	right: 1.3rem;
	bottom: 1.3rem;
	body[dir='rtl'] & {
		right: unset;
		left: 1.3rem;
	}
`;

export const IconContainer = styled.div`
	min-height: 100%;
	display: flex;
	align-items: center;
	> div {
		min-height: 100%;
		display: flex;
		align-items: center;
		transform: translateY(5%);
	}
`;

export const CardContainer = styled.div`
	.card {
		padding: 3rem 1.5rem;
		display: flex;
		flex-wrap: wrap;
		position: relative;
		height: 100%;
	}
`;

export const TooltipContainer = styled.div`
	.tooltip {
		color: #878b97;
	}
`;
